import { TCIconsName, TPositions } from 'components/CustomIcon';
import { routePaths } from 'constants/routes';
import { verificationRolesExists } from 'constants/allfunctions';
import { getRolesUser } from 'services/rolesList';

const size = '30px';

export interface IMenuItem {
  icon: {
    type: TCIconsName;
    size: string;
    position: TPositions;
  };
  text: string;
  onPopup?: {
    title: string;
    options: {
      title: string;
      text: string;
      img: string;
      href?: string;
      event?: string;
      disabled?: boolean;
      isPage: boolean;
      userType?: 'admin' | 'client';
    }[];
  };
  href?: string;
  disabled?: boolean;
  isPage: boolean;
  userType?: 'admin' | 'client';
  hidden?: boolean;
}

const getRoles = async (id: string, typeRole: string) => {
  const response = await getRolesUser(id);

  const roles = response.data.roles;

  return roles.some(item => item.name === typeRole);
};

export const verificationMenuOpsClient = async (id: string) => {
  const menu: IMenuItem[] = [
    {
      icon: {
        type: 'edit',
        size,
        position: 'bottom-right',
      },
      text: 'Tenho um novo contrato, documento ou projeto para análise',
      onPopup: {
        title: 'Tenho um novo contrato, documento ou projeto para análise',
        options: [
          {
            img: require('assets/images/popup-images/new-sol.png').default,
            title: 'Quero assinar um novo contrato com um novo parceiro',
            text: 'Aqui você poderá avaliar o nível de conformidade de um terceiro à LGPD',
            href: routePaths.thirdPartyAssessment,
            disabled:
              // eslint-disable-next-line no-unneeded-ternary
              !(await getRoles(id, 'ROLE_ASSESSMENT_TERCEIROS')),
            // !verificationRolesExists('ROLE_ASSESSMENT_TERCEIROS'),
            isPage: true,
          },
          {
            img: require('assets/images/popup-images/aspect-privaci.png').default,
            title: 'Quero avaliar aspectos de privacidade e proteção de dados de um novo projeto',
            text: 'Clique aqui para realizar uma análisde de privacy by design',
            href: routePaths.evaluationProject,
            disabled:
              // eslint-disable-next-line no-unneeded-ternary
              !(await getRoles(id, 'ROLE_AVALIACAO_NOVOS_PROJETOS')),
            // !verificationRolesExists('ROLE_AVALIACAO_NOVOS_PROJETOS'),
            isPage: true,
          },
          {
            img: require('assets/images/popup-images/anali.png').default,
            title: 'Quero submeter um documento para análise jurídica',
            text: 'Clique aqui para enviar um contrato ou documento para análise jurídica, de PI, privacidade ou aspectos gerais, da Equipe Daniel',
            href: routePaths.newClientDemands + '?serviceType=12',
            disabled:
              // eslint-disable-next-line no-unneeded-ternary
              !(await getRoles(id, 'ROLE_CONSULTAS_DOCUMENTOS_CONTRATOS')),

            // !verificationRolesExists('ROLE_CONSULTAS_DOCUMENTOS_CONTRATOS'),
            isPage: true,
          },
          {
            img: require('assets/images/popup-images/aval.png').default,
            title: 'Quero avaliar o nível de conformidade do site ou App contratado',
            text: 'Clique aqui para fazer a avaliação dos aspectos de privacidade de um site ou App que você deseja contratar',
            disabled: true,
            // disabled:
            //   // eslint-disable-next-line no-unneeded-ternary
            //  verificationRolesExists('ROLE_CHECK_LIST_SITES_APPS')
            //     ? false
            //     : true,
            isPage: false,
          },
        ],
      },
      disabled: false,
      isPage: true,
    },

    {
      icon: {
        type: 'todo',
        size,
        position: 'center',
      },
      text: 'Quero mapear uma atividade de tratamento de dados pessoais',
      href: routePaths.ropa,
      disabled:
        // eslint-disable-next-line no-unneeded-ternary
        !(await getRoles(id, ' ROLE_REGISTRO_OPERACAO_TRATAMENTO_DADOS')),
      // !verificationRolesExists('ROLE_REGISTRO_OPERACAO_TRATAMENTO_DADOS'),
      isPage: true,
    },
    {
      icon: {
        type: 'shield',
        size,
        position: 'top-right',
      },
      text: 'Tive um incidente de segurança e quero saber os próximos passos',
      disabled: true,
      userType: 'client',
      onPopup: {
        title: 'Tive um incidente de segurança e quero saber os próximos passos',
        options: [
          {
            img: require('assets/images/popup-images/incidents-severity.png').default,
            title: 'Quero avaliar a gravidade do incidente',
            text: 'Sempre que houver algum incidente, clique aqui para avaliar sua gravidade',
            href: '',
            disabled: true,
            isPage: false,
          },
          {
            img: require('assets/images/popup-images/incident-notification.png').default,
            title: 'Quero criar uma notificação de incidente de segurança',
            text: 'Entre aqui para criar uma notificação no caso de um incidente de segurança',
            href: '',
            disabled: true,
            isPage: false,
          },
        ],
      },
      isPage: false,
    },

    {
      icon: {
        type: 'number',
        size,
        position: 'center',
      },
      text: 'Quero avaliar minhas práticas de segurança da informação ',
      userType: 'client',
      disabled: true,
      isPage: false,
    },
    {
      icon: {
        type: 'dolar',
        size,
        position: 'center',
      },
      text: 'Quero gerenciar meu orçamento e acompanhar minhas demandas',
      href: routePaths.budgetControl,
      disabled:
        // eslint-disable-next-line no-unneeded-ternary
        !(await getRoles(id, 'ROLE_CONTROLE_ORCAMENTARIO')),

      isPage: true,
    },
    {
      icon: {
        type: 'user_alt',
        size,
        position: 'top',
      },
      text: 'Quero gerenciar os acessos dos meus usuários ao DPO Hub',
      onPopup: {
        title: 'Quero gerenciar o acesso de meus usuários ao DPO Hub',
        options: [
          {
            img: require('assets/images/popup-images/new-user.png').default,
            title: 'Quero criar um novo usuário',
            text: 'Aqui você pode criar um novo usuário e definir suas permissões de acesso',
            href: routePaths.newuser,
            isPage: true,
          },
          {
            img: require('assets/images/popup-images/permissions.png').default,
            title: 'Quero alterar permissões de usuários já existentes',
            text: 'Aqui você pode alterar informações e acessos de usuários ou inativá-los',
            href: routePaths.users,
            isPage: true,
          },
        ],
      },
      disabled:
        // eslint-disable-next-line no-unneeded-ternary
        !(await getRoles(id, 'ROLE_GESTAO_USUARIOS')),

      // verificationRolesExists('ROLE_GESTAO_USUARIOS') ? false : true,
      isPage: true,
    },
    {
      icon: {
        type: 'tree',
        size,
        position: 'top',
      },
      text: 'Quero visualizar as minhas atividades no DPO Hub',
      href: routePaths.dashBoard,
      disabled: false,
      isPage: true,
    },
  ];

  return menu;
};

export const menuOpsClient: IMenuItem[] = [
  {
    icon: {
      type: 'edit',
      size,
      position: 'bottom-right',
    },
    text: 'Tenho um novo contrato, documento ou projeto para análise',
    onPopup: {
      title: 'Tenho um novo contrato, documento ou projeto para análise',
      options: [
        {
          img: require('assets/images/popup-images/new-sol.png').default,
          title: 'Quero assinar um novo contrato com um novo parceiro',
          text: 'Aqui você poderá avaliar o nível de conformidade de um terceiro à LGPD',
          href: routePaths.thirdPartyAssessment,
          disabled:
            // eslint-disable-next-line no-unneeded-ternary

            !verificationRolesExists('ROLE_ASSESSMENT_TERCEIROS'),
          isPage: true,
        },
        {
          img: require('assets/images/popup-images/aspect-privaci.png').default,
          title: 'Quero avaliar aspectos de privacidade e proteção de dados de um novo projeto',
          text: 'Clique aqui para realizar uma análisde de privacy by design',
          href: routePaths.evaluationProject,
          disabled:
            // eslint-disable-next-line no-unneeded-ternary

            !verificationRolesExists('ROLE_AVALIACAO_NOVOS_PROJETOS'),
          isPage: true,
        },
        {
          img: require('assets/images/popup-images/anali.png').default,
          title: 'Quero submeter um documento para análise jurídica',
          text: 'Clique aqui para enviar um contrato ou documento para análise jurídica, de PI, privacidade ou aspectos gerais, da Equipe Daniel',
          href: routePaths.newClientDemands + '?serviceType=12',
          disabled:
            // eslint-disable-next-line no-unneeded-ternary

            !verificationRolesExists('ROLE_CONSULTAS_DOCUMENTOS_CONTRATOS'),
          isPage: true,
        },
        {
          img: require('assets/images/popup-images/aval.png').default,
          title: 'Quero avaliar o nível de conformidade do site ou App contratado',
          text: 'Clique aqui para fazer a avaliação dos aspectos de privacidade de um site ou App que você deseja contratar',
          disabled: true,
          // disabled:
          //   // eslint-disable-next-line no-unneeded-ternary
          //  verificationRolesExists('ROLE_CHECK_LIST_SITES_APPS')
          //     ? false
          //     : true,
          isPage: false,
        },
      ],
    },
    disabled: false,
    isPage: true,
  },
  {
    icon: {
      type: 'todo',
      size,
      position: 'center',
    },
    text: 'Quero mapear uma atividade de tratamento de dados pessoais',
    href: routePaths.ropa,
    disabled:
      // eslint-disable-next-line no-unneeded-ternary

      !verificationRolesExists('ROLE_REGISTRO_OPERACAO_TRATAMENTO_DADOS'),
    isPage: true,
  },
  {
    icon: {
      type: 'shield',
      size,
      position: 'top-right',
    },
    text: 'Tive um incidente de segurança e quero saber os próximos passos',
    disabled: true,
    userType: 'client',
    onPopup: {
      title: 'Tive um incidente de segurança e quero saber os próximos passos',
      options: [
        {
          img: require('assets/images/popup-images/incidents-severity.png').default,
          title: 'Quero avaliar a gravidade do incidente',
          text: 'Sempre que houver algum incidente, clique aqui para avaliar sua gravidade',
          href: '',
          disabled: true,
          isPage: false,
        },
        {
          img: require('assets/images/popup-images/incident-notification.png').default,
          title: 'Quero criar uma notificação de incidente de segurança',
          text: 'Entre aqui para criar uma notificação no caso de um incidente de segurança',
          href: '',
          disabled: true,
          isPage: false,
        },
      ],
    },
    isPage: false,
  },

  {
    icon: {
      type: 'number',
      size,
      position: 'center',
    },
    text: 'Quero avaliar minhas práticas de segurança da informação ',
    userType: 'client',
    disabled: true,
    isPage: false,
  },
  {
    icon: {
      type: 'dolar',
      size,
      position: 'center',
    },
    text: 'Quero gerenciar meu orçamento e acompanhar minhas demandas',
    href: routePaths.budgetControl,
    disabled:
      // eslint-disable-next-line no-unneeded-ternary
      verificationRolesExists('ROLE_CONTROLE_ORCAMENTARIO') ? false : true,
    isPage: true,
  },
  {
    icon: {
      type: 'user_alt',
      size,
      position: 'top',
    },
    text: 'Quero gerenciar os acessos dos meus usuários ao DPO Hub',
    onPopup: {
      title: 'Quero gerenciar o acesso de meus usuários ao DPO Hub',
      options: [
        {
          img: require('assets/images/popup-images/new-user.png').default,
          title: 'Quero criar um novo usuário',
          text: 'Aqui você pode criar um novo usuário e definir suas permissões de acesso',
          href: routePaths.newuser,
          isPage: true,
        },
        {
          img: require('assets/images/popup-images/permissions.png').default,
          title: 'Quero alterar permissões de usuários já existentes',
          text: 'Aqui você pode alterar informações e acessos de usuários ou inativá-los',
          href: routePaths.users,
          isPage: true,
        },
      ],
    },
    disabled:
      // eslint-disable-next-line no-unneeded-ternary
      verificationRolesExists('ROLE_GESTAO_USUARIOS') ? false : true,
    isPage: true,
  },
  {
    icon: {
      type: 'tree',
      size,
      position: 'top',
    },
    text: 'Quero visualizar as minhas atividades no DPO Hub',
    href: routePaths.dashBoard,
    disabled: false,
    isPage: true,
  },
];

export const menuOpsAdmin: IMenuItem[] = [
  {
    icon: {
      type: 'edit',
      size,
      position: 'bottom-right',
    },
    text: 'Tenho um novo contrato, documento ou projeto para análise',
    onPopup: {
      title: 'Tenho um novo contrato, documento ou projeto para análise',
      options: [
        {
          img: require('assets/images/popup-images/new-sol.png').default,
          title: 'Quero assinar um novo contrato com um novo parceiro',
          text: 'Aqui você poderá avaliar o nível de conformidade de um terceiro à LGPD',
          href: routePaths.thirdPartyAssessment,
          isPage: true,
        },
        {
          img: require('assets/images/popup-images/aspect-privaci.png').default,
          title: 'Quero avaliar aspectos de privacidade e proteção de dados de um novo projeto',
          text: 'Clique aqui para realizar uma análisde de privacy by design',
          href: routePaths.evaluationProject,
          isPage: true,
        },
        {
          img: require('assets/images/popup-images/anali.png').default,
          title: 'Quero submeter um documento para análise jurídica',
          text: 'Clique aqui para enviar um contrato ou documento para análise jurídica, de PI, privacidade ou aspectos gerais, da Equipe Daniel',
          href: routePaths.newDemand,
          isPage: true,
        },
        {
          img: require('assets/images/popup-images/aval.png').default,
          title: 'Quero avaliar o nível de conformidade do site ou App contratado',
          text: 'Clique aqui para fazer a avaliação dos aspectos de privacidade de um site ou App que você deseja contratar',
          href: '',
          disabled: true,
          userType: 'client',
          isPage: false,
        },
      ],
    },
    isPage: true,
  },
  {
    icon: {
      type: 'todo',
      size,
      position: 'center',
    },
    text: 'Quero mapear uma atividade de tratamento de dados pessoais',
    href: routePaths.ropa,
    disabled: false,
    isPage: true,
  },
  {
    icon: {
      type: 'shield',
      size,
      position: 'top-right',
    },
    text: 'Tive um incidente de segurança e quero saber os próximos passos',
    disabled: false,
    userType: 'client',
    onPopup: {
      title: 'Tive um incidente de segurança e quero saber os próximos passos',
      options: [
        {
          img: require('assets/images/popup-images/incidents-severity.png').default,
          title: 'Quero avaliar a gravidade do incidente',
          text: 'Sempre que houver algum incidente, clique aqui para avaliar sua gravidade',
          href: '',
          disabled: true,
          isPage: false,
        },
        {
          img: require('assets/images/popup-images/incident-notification.png').default,
          title: 'Quero criar uma notificação de incidente de segurança',
          text: 'Entre aqui para criar uma notificação no caso de um incidente de segurança',
          href: '',
          disabled: true,
          isPage: false,
        },
      ],
    },
    isPage: false,
  },

  {
    icon: {
      type: 'number',
      size,
      position: 'center',
    },
    text: 'Quero avaliar minhas práticas de segurança da informação ',
    userType: 'client',
    isPage: false,
  },
  {
    icon: {
      type: 'dolar',
      size,
      position: 'center',
    },
    text: 'Quero gerenciar meu orçamento e acompanhar minhas demandas',
    href: routePaths.budgetControl,
    isPage: true,
  },
  {
    icon: {
      type: 'user_alt',
      size,
      position: 'top',
    },
    text: 'Quero gerenciar os acessos dos meus usuários ao DPO Hub',
    onPopup: {
      title: 'Quero gerenciar o acesso de meus usuários ao DPO Hub',
      options: [
        {
          img: require('assets/images/popup-images/new-user.png').default,
          title: 'Quero criar um novo usuário',
          text: 'Aqui você pode criar um novo usuário e definir suas permissões de acesso',
          href: routePaths.newuser,
          isPage: true,
        },
        {
          img: require('assets/images/popup-images/permissions.png').default,
          title: 'Quero alterar permissões de usuários já existentes',
          text: 'Aqui você pode alterar informações e acessos de usuários ou inativá-los',
          href: routePaths.users,
          isPage: true,
        },
      ],
    },
    isPage: true,
  },
  {
    icon: {
      type: 'tree',
      size,
      position: 'top',
    },
    text: 'Quero visualizar as minhas atividades no DPO Hub',
    href: routePaths.dashBoard,
    isPage: true,
  },
];
